/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Input, Radio, Icon } from "semantic-ui-react";
import { Spinner } from 'react-bootstrap';
import { translate } from "react-i18next";
import { Formik, Field } from "formik";
import { Label, Image, Segment, Form as FormUi, Dimmer, Loader, Checkbox, Dropdown, Table, Container, Button as SemanticButton } from "semantic-ui-react";
import ImportFile from "./importModal";
import CreateUserRoleModal from "./userRoleModal";
import { connect } from "react-redux";
import { DateData } from "../../components/apiInputs/dateData";
import {LOCAL_STORAGE, DATE_FORMATS} from '../../utils/constant'
import MyVendorComponent from "../dynamicComponent/vendorSearch";
import MyVehicleMaster from "../apiInputs/vehicleNumberDropdown";

const TitleBar = (props) => {

  const [ImportModalState, setImportModalState] = useState(false);
  const [createPermissionModalState, setcreatePermissionImportModalState] = useState(false);
  const [Permissions, setPermissions] = useState(false);
  const [visible, setVisible] = useState(false)
  const [filterData, setFilterData] = useState()
  const [values, setValues] = useState()
  useEffect(() => {
    checkPermission()
  }, [Permissions]);

  const handleImportClose = () => {
    setImportModalState(false);
    window.location.reload();
  };

  const handlepermissionModal = () => {
    setcreatePermissionImportModalState(true);
  }

  const handlepermissionModalClose = () => {
    setcreatePermissionImportModalState(false);
    // window.location.reload();
  };

  const handleImportOpen = () => {
    setImportModalState(true);
  };

 const handleFilter = () => {
    setVisible(!visible)
    setFilterData(null)
  }

  const checkPermission = () => {
    switch (props.title) {
      case ('Fornecedor'):
        setPermissions(!props.permissions.TA_VENDOR_MASTER.CREATE)
        break;
      case ('Vendor'):
        setPermissions(!props.permissions.TA_VENDOR_MASTER.CREATE)
        break;
      case ('Vendor Share'):
        setPermissions(!props.permissions.TA_VENDOR_SHARE.CREATE)
        break;
      case ('Vendor Share'):
        setPermissions(!props.permissions.TA_VENDOR_SHARE.CREATE)
        break;
      case ('Vendor Group'):
        setPermissions(!props.permissions.TA_VENDOR_GROUP.CREATE)
        break;
      case ('Grupo de Fornecedores'):
        setPermissions(!props.permissions.TA_VENDOR_GROUP.CREATE)
        break;
      case ('Vehicle Type'):
        setPermissions(!props.permissions.TA_VEHICLE_TYPE_MASTER.CREATE)
        break;
      case ('Tipo de Veículo'):
        setPermissions(!props.permissions.TA_VEHICLE_TYPE_MASTER.CREATE)
        break;
      case ('Users'):
        setPermissions(!props.permissions.TA_USER_MASTER.CREATE)
        break;
      case ('Comercial'):
        setPermissions(!props.permissions.TA_USER_MASTER.CREATE)
        break;
      case ('Drivers'):
        setPermissions(!props.permissions.TA_DRIVER_MASTER.CREATE)
        break;
      case ('Motoristas'):
        setPermissions(!props.permissions.TA_DRIVER_MASTER.CREATE)
        break;
      case ('Consignor'):
        setPermissions(!props.permissions.TA_CONSIGNOR_MASTER.CREATE)
        break;
      case ('Expedidor'):
        setPermissions(!props.permissions.TA_CONSIGNOR_MASTER.CREATE)
        break;
      case ('Consignee'):
        setPermissions(!props.permissions.TA_CONSIGNEE_MASTER.CREATE)
        break;
      case ('Consignatário'):
        setPermissions(!props.permissions.TA_CONSIGNEE_MASTER.CREATE)
        break;
      case ('City'):
        setPermissions(!props.permissions.TA_CITY_MASTER.CREATE)
        break;
      case ('Cidade'):
        setPermissions(!props.permissions.TA_CITY_MASTER.CREATE)
        break;
      case ('Route'):
        setPermissions(!props.permissions.TA_CHECKPOINT_MASTER.CREATE)
        break;
      case ('Rota'):
        setPermissions(!props.permissions.TA_CHECKPOINT_MASTER.CREATE)
        break;
      case ('Product'):
        setPermissions(!props.permissions.TA_SKU_MASTER.CREATE)
        break;
      case ('Produtos'):
        setPermissions(!props.permissions.TA_SKU_MASTER.CREATE)
        break;
      case ('Users'):
        setPermissions(!props.permissions.TA_USER_ROLE.CREATE)
        break;
      case ('Papel do usuário'):
        setPermissions(!props.permissions.TA_USER_ROLE.CREATE)
        break;
      default:
        break;
    }
  }

  const { t } = props;
  return (
    <div id="dispatch_bar">
      <div className="container-fluid dip_bar">
        <div className="row">
          <div className="col-sm-12">
            <div className="d-flex justify-content-between">
              <h2 className="page-title">{props.title}</h2>
              {props.hideTitleBarTools ? '' : <div className="form-inline">
                {/* <span>{this.state.path}</span> */}
                {props.radioToggle && (
                  <Radio
                    toggle
                    className="mr-1"
                    name="gridView"
                    checked={props.toggle}
                    onChange={props.toggleView}
                  />
                )}
                <Input size="mini" 
                icon={{ name: 'search', circular: true }} 
                onKeyUp={props.handleSearch} 
                className="mr-1 ml-1" 
                placeholder={t("search") || "Search"} />
                {/* <div className="input-group search_bar">
                  <div className="input-group-prepend">
                    <span
                      className="input-group-text w3-white w3-round"
                      style={{
                        border: "1px solid #E3E3E3",
                        borderRadius: "2
                        .
                        0px 0px 0px 20px",
                      }}
                      id="basic-addon1"
                    >
                      <i className="fas fa-search"></i>
                    </span>
                  </div>
                  <input
                    style={{
                      textAlign: "start",
                      height: "30px",
                      borderRadius: "0px 20px 20px 0px",
                    }}
                    type="text"
                    className="form-control"
                    id="searchbox"
                    onKeyUp={props.handleSearch}
                    placeholder={t("search") || "Search"}
                    aria-label="Search"
                    aria-describedby="basic-addon1"
                  />
                </div> */}
                {props.title == "Order Placement Ratio" || props.title == 'In-Transit Vehicles' || props.title == 'Vehicle Availability' || props.title == "Hire Memo" || props.title == 'Purchase Orders' ? (
                  null
                ) : (
                  <button
                    type="button"
                    data-toggle="modal"
                    data-target="#ImportXL"
                    hidden={props.importHidden}
                    onClick={() => handleImportOpen()}
                    className="grey-btn">
                    <i class="fas fa-file-import mr-1"></i>
                    {t("import") || "Import"}
                  </button>
                )}


                 <button
                  type="button"
                  data-toggle="modal"
                  data-target="#ExportXL"
                  hidden={props.exportHidden}
                  onClick={props.exportDataGrid}
                  className="grey-btn"
                  disabled={props.exportLoading ? true : false}
                >
                  {props.exportLoading ? <Icon name={"loading spinner"} /> : <i class="fas fa-file-export mr-1"></i>}
                  {t("export") || "Export"}
                </button> 

               {!props.hideFilter && <button onClick={handleFilter} 
                className="grey-btn">
                  <i class="fas fa-filter"></i> {t("filter") || "Filter"}
                </button>}

                {console.log(props.title)}

                {props.title == "Hire Memo" || props.title == 'Purchase Orders' ? null : props.title == "User Role" || props.title == "Deliveries" || props.title == "Papel do usuário" || props.title == "Hire Memo" ? (
                  <button
                    type="button"
                    data-toggle="modal"
                    data-target="#Permission"
                    icon="fas fa-plus"
                    hidden={Permissions}
                    onClick={() => handlepermissionModal()}
                    size="mini"
                    className="grey-btn-new"
                  >
                    <i className="fas fa-plus"></i>{t("new") || "New"}
                  </button>
                ) : (
                  <>
                    {props.title == "Order Placement Ratio" || props.title == 'In-Transit Vehicles' || props.title == 'Vehicle Availability' || props.title == 'Purchase Orders' ? (
                      null
                    ) : (
                      <Link
                        hidden={Permissions}
                        to={props.LinkName}
                        className="grey-btn-new"
                      >
                        <i className="fas fa-plus"></i> {t("new") || "New"}
                      </Link>
                    )}
                  </>
                )}

              </div> }
            </div>
          </div>
        </div>
      </div>
      {visible ?
          <Formik className="animate backInDown"
            enableReinitialize
            initialValues={{
              transporter: LOCAL_STORAGE.vendorCode ? LOCAL_STORAGE.vendorCode : '',
              vehicleStatus: '',
              route: '',
              destination: '',
              vehicleNo: '',
              trackingType: '',
              startDate: '',
              endDate: '',
              transporterId: '',
              vehicleId: '',
              customerNo: LOCAL_STORAGE.customerNo,
              userId: LOCAL_STORAGE.userId
            }}
            onSubmit={(values, { setSubmitting }) => {
              console.log(values,"values on submit");
              props.propsFromChild(values)
              { if ((values.startDate && values.endDate)|| values.transporterId || values.vehicleId) { this.props.propsFromChild(values) } }
              { setValues( { values } ) }
              setoffsetLimit(0)
              let startDate = values.startDate ? moment(values.startDate).format(DATE_FORMATS.DATE_YYYYMMDD) : ''
              let endDate = values.endDate ? moment(values.endDate).format(DATE_FORMATS.DATE_YYYYMMDD) : ''
              let transporter = values.transporter == 'null' ? "" : values.transporter
              let combineParams = { ...values, startDate, endDate, transporter }
              setSubmitting(true)
              if (!this.props.filterApiResponse) {
                this.setState({ filterData: { ...combineParams } })
                // this.setState({ searchLoading: false })
                setSubmitting(false)
              }
            }}
          >
            {({ values, isSubmitting, handleSubmit }) => {
              return (
                <Segment className="ui form tiny">
                  <FormUi.Group inline>
                    <FormUi.Field width={3}>
                      <label>Start Date:</label>
                    </FormUi.Field>
                    <FormUi.Field width={3}>
                      <DateData
                        autoComplete="off"
                        name="startDate"
                        popperClassName="date"
                        isClearable
                        dateFormat={DATE_FORMATS.ddMMyyyy}
                        selected={values.startDate}
                        maxDate={values.endDate}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            handleSubmit()
                          }
                        }}
                        selectsStart
                        customInput={<input className="p-dateforStd" autoComplete="off" icon="time" iconPosition="left"
                        />}
                      />
                    </FormUi.Field>
                    <FormUi.Field width={1} />
                    <FormUi.Field width={2}>
                      <label>End Date:</label>
                    </FormUi.Field>
                    <FormUi.Field width={3}>
                      <DateData
                        name="endDate"
                        selectsEnd
                        autoComplete="off"
                        popperClassName="date"
                        isClearable
                        minDate={values.startDate}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            handleSubmit()
                          }
                        }}
                        dateFormat={DATE_FORMATS.ddMMyyyy}
                        customInput={<input icon="time" iconPosition="left"
                        />}
                      />
                    </FormUi.Field>
                    <FormUi.Field width={1} />
                  </FormUi.Group>

                  <FormUi.Group inline>
                    <FormUi.Field width={3}>
                      <label>Vendor</label>
                    </FormUi.Field>
                    <FormUi.Field width={3}>
                      <Field
                      component={MyVendorComponent}
                      name="transporterId"
                      clearable
                      />
                    </FormUi.Field>
                    <FormUi.Field width={1} />
                    <FormUi.Field width={2}>
                      <label>Vehicle Number</label>
                    </FormUi.Field>
                    <FormUi.Field width={3}>
                     <Field
                      component={MyVehicleMaster}
                      name="vehicleId"
                      clearable
                      idValue={true}
                      />
                    </FormUi.Field>
                    <FormUi.Field width={1} />
                  </FormUi.Group>
                  <button type="button" onClick={handleSubmit} className="w3-button w3-small w3-blue w3-round w3-hover-blue p-outline-none">Search</button>
                </Segment>
              )
            }}
          </Formik>
          : ''}
      <ImportFile
        openBox={ImportModalState}
        handleClose={handleImportClose}
        fileName={props.pathName}
        baseURL={props.baseURL}
        moduleName={props.moduleName}
      />
      <CreateUserRoleModal
        openBox={createPermissionModalState}
        handleClose={handlepermissionModalClose}
      // fileName={props.baseURL}
      // baseURL={props.baseURL}
      />
    </div>
  );
};
const mapStateToProps = ({ permissions }) => {
  return {
    permissions,
  }
}
export default connect(mapStateToProps)(translate("title_bar")(TitleBar));
